package app.bloomey.web.core.data.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Category(
    @SerialName("_id")
    val id: String,
    val image: String,
    val color: String,
    val title: String,
    val description: String,
    val videoCount: Int,
    val ownerId: String,
    val createdAt: Long,
    val lastWatched: LastWatched? = null,
) {

    @Serializable
    data class LastWatched(
        val videoId: String,
        val dateTime: Long,
    )

    enum class OrderBy {
        createdAt,
        lastWatched
    }
}

@Serializable
data class CategoryUpdateRequest(
    val image: String,
    val color: String,
    val title: String,
    val description: String,
)